export default __webpack_public_path__ + "static/17-335ee84aad439099ae48dd94f5075e2c.png";